export const API_URL = "/api";

export const TRANSFER_STATUS = {
    OPEN: 0,
    ASSIGNED: 1,
    CLOSED: 2,
    CANCELED: 3
}

export const TRANSFER_STATUSES = [
    'Pending', 'Pending', 'Closed', 'Canceled'
];

export const LOCATION_TYPE = {
    DEFAULT: 0,
    AIRPORT: 1,
    PORT: 2,
    HOTEL: 3
}

export const ROUTE_TYPE = {
    TRANSFER: 0,
    ARRIVAL: 1,
    DEPARTURE: 2,
    TOUR: 3,
}

export const ROUTE_TITLES = {
    'arrival': "Arrival Transfer",
    'departure': "Departure Transfer",
    'hotel': "Private Transfer",
    'location': "Private Transfer",
}

export const SUMMARY_TITLES = {
    'arrival': "Arrival Transfer",
    'departure': "Departure Transfer",
    'hotel': "Private Transfer",
    'location': "Private Transfer",
}

export const PAYMENT_TYPE = {
    CASH: 1,
    CARD: 3,
    BANK: 4,
}

export const RESERVATION_STATUS = {
    ON_PROGRESS: 0,
    NEW: 1,
    COMPLETED: 2,
    FAILED: 3,
    CANCELED: 4,
}

export const CONTACT = {
    EMAIL: "info@regentmile.gr",
    PHONE: "+30 6972 375 628",
    WHATSAPP: "+30 6972 375 628",
    VIBER: "+30 6972 375 628",
}

export let dummyFunction = () => {
};


